import React, { useEffect, useState } from 'react';
import "./../styles/project-card.css"

import amazon2 from "./../assets/svg/stack/amazon2.svg"
import aws from "./../assets/svg/stack/aws.svg"
import css from "./../assets/svg/stack/css.svg"
import django from "./../assets/svg/stack/django.svg"
import docker from "./../assets/svg/stack/docker.svg"
import docusign from "./../assets/svg/stack/docusign.svg"
import facebook from "./../assets/svg/stack/facebook.svg"
import flask from "./../assets/svg/stack/flask.svg"
import google from "./../assets/svg/stack/google.svg"
import html from "./../assets/svg/stack/html.svg"
import instagram from "./../assets/svg/stack/instagram.svg"
import jinja2 from "./../assets/svg/stack/jinja2.svg"
import js from "./../assets/svg/stack/js.svg"
import linkedin from "./../assets/svg/stack/linkedin.svg"
import pandas from "./../assets/svg/stack/pandas.svg"
import paypal from "./../assets/svg/stack/paypal.svg"
import postgresql from "./../assets/svg/stack/postgresql.svg"
import python from "./../assets/svg/stack/python.svg"
import react from "./../assets/svg/stack/react.svg"
import redis from "./../assets/svg/stack/redis.svg"
import shopify from "./../assets/svg/stack/shopify.svg"
import sp from "./../assets/svg/stack/sp.svg"
import stripe from "./../assets/svg/stack/stripe.svg"
import firebase from "./../assets/svg/stack/firebase.svg"
import git from "./../assets/svg/stack/git.svg"
import github from "./../assets/svg/stack/github.svg"
import tensor from "./../assets/svg/stack/tensor.svg"
import heroku from "./../assets/svg/stack/heroku.svg"
import tiktok from "./../assets/svg/stack/tiktok.svg"
import digital from "./../assets/svg/stack/digital.svg"
import mysql from "./../assets/svg/stack/mysql.svg"
import greendot from "./../assets/svg/stack/greendot.svg"
import bluedot from "./../assets/svg/stack/bluedot.svg"
import celery from "./../assets/svg/stack/celery.svg"
import mongo from "./../assets/svg/stack/mongo.svg"
import helm from "./../assets/svg/stack/helm.svg"
import kubernetes from "./../assets/svg/stack/kubernetes.svg"
import azure_aks from "./../assets/svg/stack/azure_aks.svg"
import azure_devops from "./../assets/svg/stack/azure_devops.svg"
import grafana from "./../assets/svg/stack/grafana.svg"
import astro from "./../assets/svg/stack/astro.svg"
import openai from "./../assets/svg/stack/openai.svg"
import azure_functions from "./../assets/svg/stack/azure_functions.png"
import elasticsearch from "./../assets/svg/stack/elasticsearch.png"
import mssql from "./../assets/svg/stack/mssql.png"
import gtm from "./../assets/svg/stack/gtm.png"
import seo from "./../assets/svg/stack/seo.svg"
import sso from "./../assets/svg/stack/sso.svg"

const ProjectCard = ({ link, image, name, stack, phase, description }) => {
    const stack_images = {
        "python": python,
        "react": react,
        "django": django,
        "postgreSQL": postgresql,
        "AWS": aws,
        "amazon2": amazon2,
        "CSS": css,
        "docker": docker,
        "docusign": docusign,
        "facebook": facebook,
        "flask": flask,
        "google": google,
        "HTML": html,
        "instagram": instagram,
        "jinja2": jinja2,
        "JS": js,
        "linkedIn": linkedin,
        "pandas": pandas,
        "payPal": paypal,
        "redis": redis,
        "shopify": shopify,
        "Amazon SP-API": amazon2,
        "stripe": stripe,
        "firebase": firebase,
        "git": git,
        "github": github,
        "TensorFlow": tensor,
        "heroku": heroku,
        "tikTok": tiktok,
        "digitalOcean": digital,
        "mySQL": mysql,
        "celery": celery,
        "mongo": mongo,
        "helm": helm,
        "kubernetes": kubernetes,
        "Azure DevOps": azure_devops,
        "Azure Container Registry": azure_aks,
        "grafana": grafana,
        "astro": astro,
        "OpenAI": openai,
        "Azure Functions": azure_functions,
        "ElasticSearch/OpenSearch": elasticsearch,
        "Google Tag Manager": gtm,
        "MSSQL": mssql,
        "SEO": seo,
        "Single Sign-On (SSO)": sso,
    }
    const phase_color = {
        "Prod": greendot,
        "Frozen": bluedot,
    }

    const [hoveredSkill, setHoveredSkill] = useState(null);
    return (
        <a href={link} target="_blank" style={{ color: "inherit", textDecoration: "none" }} className='project-link'>
            <div className="card-background">
                <span className="card-name">{name}</span>
                <img src={image} className="card-image" ></img>
                <div className="d-flex flex-column description justify-content-between">
                    <div className="d-flex justify-content-between">
                        <div className="d-flex align-items-start flex-column" >
                            <span>Phase:</span>
                            <span className="d-flex"><img className="dot-wrapper" src={phase_color[phase]} />{phase}</span>
                        </div>
                        <div className="d-flex align-items-start flex-column">
                            <span>Stack:</span>
                            <span className="stack-wrapper">
                                {
                                    stack.map((el, skillIndex) => {
                                        return (
                                            <div className='position-relative stack' key={skillIndex}
                                                onMouseEnter={() => setHoveredSkill(el)}
                                                onMouseLeave={() => setHoveredSkill(null)}
                                            >
                                                {hoveredSkill === el && (
                                                    <div className="explanation-stack" >
                                                        <img className="stack-image-description" src={stack_images[el]} /> 
                                                    <span>{el.charAt(0).toUpperCase() + el.slice(1)}</span>
                                                    </div>
                                                )}
                                                <img className="stack-image" src={stack_images[el]} />
                                            </div>

                                        )
                                    })
                                }
                            </span>
                        </div>
                    </div>
                    <div className="d-flex flex-column align-items-start">
                        <span className="text-start stack-description">{description}</span>
                    </div>
                </div>
            </div>
        </a>
    );
}

export default ProjectCard;